import { persistentAtom } from './persistence';
import { DEFAULT_TEMPLATES } from '@/data/reports';

export type ReportTemplates = Record<string, string>;

/**
 * Report templates - fairly separate from other state
 */
export const $reportTemplates = persistentAtom<ReportTemplates>(
  'reportTemplates',
  DEFAULT_TEMPLATES,
);
